import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin-top: 1.5em;
`;
